var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{staticClass:"dd-m-modal--error"},[_c('LogoIcon',{attrs:{"width":"32"}}),_c('strong',[_vm._v("Erro")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }